import { connect } from 'react-redux';

import { actionCleanupDiscoveryCategories, actionGetDiscoveryCategories } from 'store/discover-category/actions';
import ManagerDiscoveryCategories from './ManagerDiscoveryCategories';

const mapStateToProps = (state) => ({
  categoriesLoading: state.DiscoverCategory.categoriesLoading,
  categories: state.DiscoverCategory.categories,
});

const mapDispatchToProps = ({
  actionGetDiscoveryCategories,
  actionCleanupDiscoveryCategories,
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagerDiscoveryCategories);
